import React, { Component } from "react";
import intl from "react-intl-universal";
import DivsPattern from "./skylineDesignPattern";

class ContactSkyline extends Component {
  constructor(props) {
    super(props);

    this.state = {
     
    };
  }  

  render() {
    return (
        <DivsPattern headerText={intl.get("Contact_Skyline_Title")} className="contactSkyline">
          <div className="form-label-group">
            <p>
              {intl.get("Contact_Skyline_Content")}
            </p>           
          </div>
        </DivsPattern>
      );
  }
}

export default ContactSkyline;
